import React from 'react';
import PropTypes from 'prop-types';

// Components
import {AttributeText} from '../../../components/components/atoms/AttributeText';
import GasSectionCardShell from '../GasSectionCardShell/GasSectionCardShell';
import GasChargesList from '../GasChargesList/GasChargesList';
import Fields from './components/Fields';

// Attributes
import dynamicFieldAttribute from '../../attributes/dynamicField.attribute.gas';

// Document/image fields are rendered separately in the Pictures section -
// this only renders the plain-value field types.
const RENDERABLE_FIELD_TYPES = ['text', 'number', 'boolean', 'date', 'datetime'];

const GasSectionCard = ({section, gas}) => {
  const meta = gas?.section_field_meta?.[section.key];
  const fields = (meta?.fields || []).filter(({type}) =>
    RENDERABLE_FIELD_TYPES.includes(type)
  );

  return (
    <GasSectionCardShell section={section} gas={gas}>
      {section.key === 'charges' && <GasChargesList gas={gas} />}
      {!!fields.length && (
        <Fields>
          {fields.map((field) => (
            <AttributeText
              key={field.field}
              attribute={dynamicFieldAttribute(field, gas?.[field.field])}
              branch={gas?.sally_branch}
            >
              {field.label}
            </AttributeText>
          ))}
        </Fields>
      )}
    </GasSectionCardShell>
  );
};

GasSectionCard.propTypes = {
  section: PropTypes.object.isRequired,
  gas: PropTypes.object,
};

export default GasSectionCard;
